import {
  Card,
  CardBody,
  Button,
  Container,
  Col,
  Row,
  CardFooter,
  Modal,
  Stack,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { LOGIN, SETTINGS, LOANDUES ,MODULEDUES} from "../../services/actions";
import { SignOut, Warning } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

// import Footer from "./Footer";
import React from "react";
// import paymentImage from "./payhuman.png";

import Badge from "react-bootstrap/Badge";
import depositsvg from "./deposits.svg";
import termsvg from "./term.svg";
import goldsvg from "./gold.svg";
import Flipcard from "./Flipcard";
import "../../App.css";
import ResponsiveText from "../../components/ResponsiveText";
import AppLayout from "../../layouts/AppLayout";
import { CardContent, Typography, Grid } from "@mui/material";
import LoanDetailsModal from "../../components/LoanDetailsModal";

export default function Dashboard() {
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const [main, setMain] = React.useState();
  let loanState = useSelector((state) => state?.loanduesState);
  let userState = useSelector((state) => state?.login);
  const [loans, setLoans] = React.useState();
  const [selectedLoans, setSelectedLoans] = React.useState(null);
  let settingsState = useSelector((state) => state?.settingsState);
  const [showModal, setShowModal] = useState(false);
  const [showDuesModal, setShowDuesModal] = useState(false);
  const moduleduesState = useSelector((state) => state.moduleduesState?.data);

  // let main = JSON.parse(localStorage.getItem("settings") || '{}')
  const [toggle, setToggle] = React.useState(0);
  const { handleSubmit, control } = useForm({
    defaultValues: { username: "admin@gmail.com", password: "Admin@123" },
    mode: "all",
  });
  let user = JSON.parse(localStorage.getItem("data") || "{}");
  console.log("localStorage", localStorage.getItem("data"));
  React.useEffect(() => {
    try {
      dispatch({
        type: `${LOANDUES}_GET`,
        payload: user.customerID,
      });

      dispatch({ type: `${SETTINGS}_GET`, payload: 1 });
    } catch (err) {}
  }, []);
  // /Flipcard
  const handlePayment = (payAmount) => {
    console.log("Payment initiated for amount:", payAmount);
  };
  // Block back navigation
  //   useEffect(() => {
  //     const handleBackButton = (event) => {
  //       event.preventDefault();
  //       navigate("/dashboard"); // Redirect users to the dashboard
  //     };
  //     window.history.pushState(null, "", window.location.href);
  //   window.addEventListener("popstate", handleBackButton);

  //   return () => {
  //     window.removeEventListener("popstate", handleBackButton);
  //   };
  // }, [navigate]);
  // end

  React.useEffect(() => {
    setLoans(loanState?.data?.data);
    console.log("LONAS:", loanState);
    console.log("Loan", loans);
  }, [loanState?.data]);

  React.useEffect(() => {
    let mainStr = settingsState?.data?.data?.main;
    let main = typeof mainStr == "string" ? JSON.parse(mainStr) : mainStr;
    localStorage.setItem("settings", JSON.stringify(main));
  }, [settingsState]);

  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault();
      setShowModal(true);
    };
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);

  const fetchLoanDetails = async (Acc_number, moduleCode,loan) => {
    try {
      if (Acc_number && moduleCode) {
        setShowDuesModal(loan)
        dispatch({
          type: `${MODULEDUES}_POST`,
          payload: {
            uniqueAccountNumber: Acc_number,
            moduleCode: moduleCode,
          },
          
        });
        console.log("Acc_number",Acc_number)
        console.log("moduleCode",moduleCode)
      }
    } catch (error) {
      console.error("Error fetching loan details:", error);
    }
  };

  const handleLeave = () => {
    setShowModal(false);
    // localStorage.setItem("data", null);
    navigate("/", { replace: true });
  };

  function toLocalTime(utcDateString) {
    const utcDate = new Date(utcDateString);

    // Convert the UTC date to local time
    const localDate = utcDate.toLocaleString();
    return localDate;
  }
  // let types = Object.keys(loans ? loans.acc_types : {});
  // console.log("types", loans.acc_types );
  return (
    <>
      <AppLayout>
        <div className="  w-100 px-4 ">
          {/* <div className="d-flex d-flex justify-content-between"> */}
          <h1 className="mb-4 mt-3 app-title">Payment Portal</h1>
          <SignOut
            size={20}
            className="mt-4 text-danger cursor-pointer"
            onClick={() => {
              localStorage.setItem("data", null);
              navigate("/", { replace: true });
            }}
          />

          {/* </div> */}
          <form
            autoComplete="false"
            onSubmit={handleSubmit((data) => {
              console.log("FORM", data);
              dispatch({ type: `${LOGIN}_AUTH`, payload: data });
            })}
          >
            <div className="my-2">
              <p>
                Welcome <b>{user?.customerName}</b>
              </p>
              <div className="my-2">
                <ResponsiveText>
                  <h1 style={{ fontWeight: "norma" }}>
                    Select a Product and Account to make a payment
                  </h1>
                </ResponsiveText>
              </div>
            </div>
            {/* Account selection */}
            <h6 className="mt-4 mb-4 app-title2 text-start">
              Financial Products
            </h6>
            {/* *************Cards********** */}
            <Container
              className="d-flex justify-content-center mb-5"
              position-fixed
              position-md-static
            >
              {loans?.acc_types.map(({ key, label }) => (
                <Grid
                  // item
                  xs={12} // Full width on extra-small screens
                  sm={6} // 2 cards per row on small screens
                  md={4} // 3 cards per row on medium screens
                  lg={3} // 4 cards per row on large screens
                  xl={2} // 6 cards per row on extra-large screens
                  key={key}
                  spacing={1}
                  sx={{
                    display: "flex",

                    mb: 3,
                    px: { xs: 0.5, sm: 0.5, md: 0.5 },
                    justifyContent: "center",
                  }}
                >
                  <Card
                    border="primary"
                    sx={{
                      height: "100%",
                      minWidth: "500px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      p: 1,
                      bgcolor: "#f5f5f5",
                      borderRadius: 2,
                      flexGrow: 1,
                    }}
                    className={`loan-box ${
                      toggle === key ? "loan-box-active" : ""
                    }`}
                    onClick={() => {
                      // if ([key]) {
                      setSelectedLoans([...loans.accounts[key]]);
                      setToggle(key);
                    }}
                    // onClick={(e) => {
                    //   setSelectedLoans([...loans.accounts.selectedLoans]);
                    //   setToggle(1);
                    // }}
                  >
                    <CardContent
                      className=" text-primary text-center justify-content-center"
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <img src={termsvg} width={40} alt="Term Loan" />
                      <Typography
                        variant="caption"
                        className="text-primary text-center mt-2 justify-content-center"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {label}
                        {console.log("Labels", label)}

                        {/* <div>
                          <Typography variant="caption">
                            Total : {acc_types.length || 0}
                          </Typography>
                        </div> */}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Container>
            {/* ********card************ */}
          </form>
          {Array.isArray(selectedLoans) && selectedLoans.length == 0 && (
            <div className="text-start">
              No Accounts available for this product
            </div>
          )}
          {Array.isArray(selectedLoans) &&
            selectedLoans.map((loan, i) => (
              <Card key={i} style={{ borderRadius: 10 }} className="mb-2">
                <CardBody style={{ border: "none" }}>
                  <Flipcard
                    onMoreClick={() =>
                      fetchLoanDetails(
                        loan.uniqueAccountNumber,
                        loan.moduleCode,
                        loan
                      )
                    }
                    loanTypeDesc={loan.loanTypeDesc}
                    Acc_number={loan.uniqueAccountNumber}
                    Disb_amt={loan.disbursedAmount}
                    Instmnt={loan.totalInstallments}
                    Due_amt={loan.dueAmount}
                    StartDate={new Date(loan.startDate).toLocaleDateString()}
                    MaturityDate={new Date(
                      loan.maturityDate
                    ).toLocaleDateString()}
                    onPay={handlePayment}
                    pledgeNetWeight={loan.pledgeNetWeight}
                    Loan={loan}
                    moduleCode={loan.moduleCode}
                    RD_redemptionDate={loan.redemptionDate}
                    RD_installmentAmount={loan.installmentAmount}
                    RD_depositType={loan.depositType}
                    interestAmountDue={loan.interestAmountDue}
                  />
                </CardBody>
              </Card>
            ))}
          <div
            className="text-primary cursor-pointer mt-2 py-4 "
            style={{ marginBottom: "100px" }}
            onClick={() => {
              navigate("/history/", {
                state: {
                  index: 2,
                },
              });
            }}
          >
            {" "}
            Transaction history
          </div>
        </div>

        {/* </Container> */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Navigation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to leave this page?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button
              variant="danger"
              // onClick={handleLeave}
              onClick={() => {
                localStorage.setItem("data", null);
                navigate("/", { replace: true });
              }}
            >
              Leave
            </Button>
          </Modal.Footer>
        </Modal>
        <LoanDetailsModal
          details={moduleduesState?.data}
          Acc_number={showDuesModal?.uniqueAccountNumber}
          show={showDuesModal}
          // loanTypeDesc={modalData.loanTypeDesc || loanTypeDesc}
          // Acc_number={modalData.Acc_number || Acc_number}
          // Disb_amt={modalData.Disb_amt || Disb_amt}
          // Due_amt={modalData.Due_amt || Due_amt}
          // StartDate={modalData.StartDate || StartDate}
          // MaturityDate={modalData.MaturityDate || MaturityDate}
          // Instmnt={modalData.Instmnt || Instmnt}
          onHide={() => setShowDuesModal(false)}
        />
      </AppLayout>
    </>
  );
}
